// SPDX-License-Identifier: MIT
import fr from './fr.json';
import en from './en.json';
import type { Locale } from './detect';

type Bundle = typeof fr;
const BUNDLES: Record<Locale, Bundle> = { fr, en };
let currentLocale: Locale = 'fr';

export function setBundleLocale(locale: Locale): void {
  currentLocale = locale;
}

export function getBundleLocale(): Locale {
  return currentLocale;
}

export function t(key: string): string {
  const parts = key.split('.');
  let node: unknown = BUNDLES[currentLocale];
  for (const part of parts) {
    if (node && typeof node === 'object' && part in (node as Record<string, unknown>)) {
      node = (node as Record<string, unknown>)[part];
    } else { return key; }
  }
  return typeof node === 'string' ? node : key;
}

// Resolve a key that points to a string array (e.g. plan feature lists).
// Returns [] when the key is missing or isn't an all-string array, so callers
// can `.map()` without guarding.
export function tList(key: string): string[] {
  const parts = key.split('.');
  let node: unknown = BUNDLES[currentLocale];
  for (const part of parts) {
    if (node && typeof node === 'object' && part in (node as Record<string, unknown>)) {
      node = (node as Record<string, unknown>)[part];
    } else { return []; }
  }
  return Array.isArray(node) && node.every((x) => typeof x === 'string') ? (node as string[]) : [];
}
